:host {
  display: block;
  max-width: 100%;
}

:host([disabled]) {
  opacity: 0.7;
  pointer-events: none;
}

:host([readonly]) {
  pointer-events: none;
}

.star-rating {
  text-align: center;
}

.star-rating input {
  display: none;
}

.star-rating label {
  gz-icon {
    &::part(svgIcon) {
      fill: var(--grey-layout-200-disabled);
    }
  }
  cursor: pointer;
}

.star-rating :checked ~ label {
  gz-icon {
    &::part(svgIcon) {
      fill: var(--orange-layout-050-warning);
    }
  }
}

.star-rating label:hover,
.star-rating label:hover ~ label {
  gz-icon {
    &::part(svgIcon) {
      fill: var(--yellow-chart-050);
    }
  }
}

gz-icon {
  &:hover {
    background-color: var(--chart-051-hover);
    border-radius: 4px;
  }
}
